import { render, staticRenderFns } from "./EditPlano.vue?vue&type=template&id=7af8696b&"
import script from "./EditPlano.vue?vue&type=script&lang=js&"
export * from "./EditPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports